import React from "react";

function BankingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2179)">
        <path
          d="M7.96403 0.0811523L0.964034 3.08115C0.526534 3.26865 0.282784 3.7374 0.379659 4.1999C0.476534 4.6624 0.882784 4.9999 1.35778 4.9999V5.2499C1.35778 5.66553 1.69216 5.9999 2.10778 5.9999H14.6078C15.0234 5.9999 15.3578 5.66553 15.3578 5.2499V4.9999C15.8328 4.9999 16.2422 4.66553 16.3359 4.1999C16.4297 3.73428 16.1859 3.26553 15.7515 3.08115L8.75153 0.0811523C8.50153 -0.0250977 8.21403 -0.0250977 7.96403 0.0811523ZM4.35778 6.9999H2.35778V13.1343C2.33903 13.1437 2.32028 13.1562 2.30153 13.1687L0.801534 14.1687C0.435909 14.4124 0.270284 14.8687 0.398409 15.2905C0.526534 15.7124 0.917159 15.9999 1.35778 15.9999H15.3578C15.7984 15.9999 16.1859 15.7124 16.314 15.2905C16.4422 14.8687 16.2797 14.4124 15.9109 14.1687L14.4109 13.1687C14.3922 13.1562 14.3734 13.1468 14.3547 13.1343V6.9999H12.3578V12.9999H11.1078V6.9999H9.10778V12.9999H7.60778V6.9999H5.60778V12.9999H4.35778V6.9999ZM8.35778 1.9999C8.623 1.9999 8.87735 2.10526 9.06489 2.2928C9.25243 2.48033 9.35778 2.73469 9.35778 2.9999C9.35778 3.26512 9.25243 3.51947 9.06489 3.70701C8.87735 3.89455 8.623 3.9999 8.35778 3.9999C8.09257 3.9999 7.83821 3.89455 7.65068 3.70701C7.46314 3.51947 7.35778 3.26512 7.35778 2.9999C7.35778 2.73469 7.46314 2.48033 7.65068 2.2928C7.83821 2.10526 8.09257 1.9999 8.35778 1.9999Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2179">
          <path d="M0.359375 0H16.3594V16H0.359375V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BankingIcon;
